<a href="{{ link }}" target="{{ target }}" mat-button [disabled]="disabled">
  <mat-icon *ngIf="icon">{{ icon }}</mat-icon>
  {{ text }}
</a>
